import { PlusIcon, UpdateIcon } from '@radix-ui/react-icons';
import { Grid } from '@radix-ui/themes';
import { CommonTableButton } from 'components/common/table/button';
import { TeamsContext } from 'contexts/admin/teams.context';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { TeamDialog } from 'lib_ts/enums/teams.enums';
import { useContext } from 'react';
import { useAuthStore } from 'stores/use-auth-store';

export const TeamsTableToolbar = () => {
  const userRoleFeatureFlags = useAuthStore((s) => s.userRoleFeatureFlags);

  const { loading, refresh, openDialog } = useContext(TeamsContext);

  return (
    <Grid columns="6" gap={RADIX.FLEX.GAP.SM}>
      <CommonTableButton
        color={RADIX.COLOR.NEUTRAL}
        icon={<UpdateIcon />}
        label="common.refresh"
        disabled={loading}
        onClick={() => refresh()}
      />

      {userRoleFeatureFlags.adminTeams.create && (
        <CommonTableButton
          color={RADIX.COLOR.SUCCESS}
          icon={<PlusIcon />}
          label="common.create"
          disabled={loading}
          onClick={() =>
            openDialog({
              mode: TeamDialog.Editor,
              team: undefined,
            })
          }
        />
      )}
    </Grid>
  );
};
